<template>
  <div>
    <ValueComparison
      :value="selectReportValueAsPercent(widgetId)"
      :comparison="selectComparisonPercent(widgetId)"
      v-if="!loading"
    />
    <ValueComparisonLoader v-else />
    <AreaGraph
      :dataSet="selectTrendData('responseRate')"
      :valueType="'percentage'"
      v-if="!!selectTrendData('responseRate')"
      :granularity="selectGranularity"
    />
  </div>
</template>

<script>
import ValueComparison from '@/components/Modules/Dashboard/Widget/ReportTypes/ValueComparison'
import ValueComparisonLoader from '@/components/Modules/Dashboard/Widget/SkeletonLoaders/ValueComparisonLoader'
import AreaGraph from '@/components/Modules/Dashboard/Widget/ReportTypes/AreaGraph'
import { createNamespacedHelpers } from 'vuex'

const DashboardModule = createNamespacedHelpers('dashboard')

export default {
  name: 'SurveyResponseRate',
  props: ['widgetId'],
  components: {
    ValueComparison,
    ValueComparisonLoader,
    AreaGraph
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...DashboardModule.mapGetters([
      'selectComparisonPercent',
      'selectReportValueAsPercent',
      'selectTrendData',
      'selectGranularity'
    ])
  },
  methods: {
    ...DashboardModule.mapActions(['fetchSurveyResponseRate'])
  },
  async mounted() {
    await this.fetchSurveyResponseRate({ widgetId: this.widgetId })
    this.loading = false
  }
}
</script>
